import css from "styled-jsx/css";
import Colors from "/styles/colors";

export const componentStyles = css`
  .card-tag {
    padding: 6px 12px;
    border: 0.5px solid ${Colors["gainsboro"]};
    .tag-text {
      font-size: 12px;
    }
  }
`;
